<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card class="lime elevation-0 rounded-0" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">
            KNDI O.S.P Professional Upgrading Examination Instructions
          </h3>
        </v-card-title>
      </v-card>
      <v-card class="elevation-0 mb-2">
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1" color="lime"
            >What are the minimum academic entry requirements ?</v-stepper-step
          >
          <v-stepper-content step="1">
            <b>Minimum Entry Requirements for a Certificate</b><br />
            A mean grade of D (plain) in the Kenya Certificate of Secondary
            Education (KCSE) with :-
            <list>
              <li>
                a grade of D (plain) in the following mandatory subjects;
                <ol>
                  <li>
                    Chemistry or physical sciences
                  </li>
                  <li>
                    Biology or biological sciences; and
                  </li>
                  <li>
                    English or Kiswahili; and
                  </li>
                </ol>
              </li>
              <li>
                a grade of D (plain) in the following subjects;
                <ol>
                  <li>
                    Physics
                  </li>
                  <li>
                    Mathematics
                  </li>
                  <li>
                    Home science
                  </li>
                  <li>
                    Agriculture; or
                  </li>
                  <li>
                    General science
                  </li>
                </ol>
              </li>
            </list>
            <b>Minimum Entry Requirements for a Diploma</b><br />
            A mean grade of C- (minus) in the Kenya Certificate of Secondary
            Education (KCSE) with :-
            <list>
              <li>
                a grade of D+ (plus) in the following mandatory subjects;
                <ol>
                  <li>
                    Chemistry or physical sciences
                  </li>
                  <li>
                    Biology or biological sciences; and
                  </li>
                  <li>
                    English or Kiswahili; and
                  </li>
                </ol>
              </li>
              <li>
                a grade of D (plain) in the following subjects;
                <ol>
                  <li>
                    Physics
                  </li>
                  <li>
                    Mathematics
                  </li>
                  <li>
                    Home science
                  </li>
                  <li>
                    Agriculture; or
                  </li>
                  <li>
                    General science
                  </li>
                </ol>
              </li>
            </list>
            <b>Minimum Entry Requirements for a Degree</b><br />
            A mean grade of C+ (plus) in the Kenya Certificate of Secondary
            Education (KCSE) with :-
            <list>
              <li>
                a grade of C (plain) in the following mandatory subjects;
                <ol>
                  <li>
                    Chemistry or physical sciences
                  </li>
                  <li>
                    Biology or biological sciences; and
                  </li>
                  <li>
                    English or Kiswahili; and
                  </li>
                </ol>
              </li>
              <li>
                a grade of C (plain) in the following subjects;
                <ol>
                  <li>
                    Physics
                  </li>
                  <li>
                    Mathematics
                  </li>
                  <li>
                    Geography
                  </li>
                </ol>
              </li>
            </list>
            <v-card class="elevation-0 mb-5" height="200px">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="lime" class="white--text" @click="e6 = 2"
                  >Continue</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2" color="lime"
            >What happens if I do not meet the entry level in any Subject
            according to my level (Certificate, Diploma or Degree requirements)
            ?</v-stepper-step
          >

          <v-stepper-content step="2">
            You are required to apply and sit for the Professional Upgrading
            Examination in the subject you did not meet the requirement as shown
            in Question 1 above.
            <v-card class="elevation-0 mb-5" height="200px">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="lime" class="white--text" @click="e6 = 3"
                  >Continue</v-btn
                >
                <v-btn color="lime" flat @click="e6 = 1">back</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3" color="lime"
            >When and how do you pay for Professional Upgrading
            Examination?</v-stepper-step
          >

          <v-stepper-content step="3">
            Each subject will cost 10,000 Kenya Shillings. Each student should
            complete this application first before making any payment. Each
            student will pay using <b>MPESA Paybill number 975775</b> and use
            only the <b>invoice number (for example INV85222)</b> that will be
            sent to their email as the Account number.
            <v-card class="elevation-0 mb-5" height="200px">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="lime"
                  class="white--text"
                  @click="
                    dialog = false
                    e6 = 1
                    dialog_terms = true
                  "
                  >Finish</v-btn
                >
                <v-btn color="lime" flat @click="e6 = 2">back</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_terms" persistent width="800">
      <v-card color="black" dark>
        <v-card-text class="white--text">
          <v-subheader>
            TERMS AND CONDITIONS
          </v-subheader>
          <v-subheader class="white--text"
            >1. You will fill your details correctly.</v-subheader
          >
          <v-subheader class="white--text"
            >2. You will select only the subject(s) that you do not meet the
            entry requirements</v-subheader
          >
          <v-subheader class="white--text"
            >Changes as a result of not adhering to the above will attract a
            penalty of KSH 1000</v-subheader
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="white--text"
            @click="
              dialog_terms = false
              check_resit = true
            "
            >ACCEPT</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper v-model="e1">
      <v-card class="lime elevation-0 rounded-0" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">
            Professional Upgrading Examination
          </h3>
        </v-card-title>
      </v-card>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          color="lime"
          v-if="step_one == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 1"
          :rules="[() => false]"
          step="1"
          v-else-if="step_one == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 2"
          step="2"
          color="lime"
          v-if="step_two == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 2"
          :rules="[() => false]"
          step="2"
          v-else-if="step_two == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 3"
          step="3"
          color="lime"
          v-if="step_three == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 3"
          :rules="[() => false]"
          step="3"
          v-else-if="step_three == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 4"
          step="4"
          color="lime"
          v-if="step_four == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 4"
          :rules="[() => false]"
          step="4"
          v-else-if="step_four == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 5"
          step="5"
          color="lime"
          v-if="step_five == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 5"
          :rules="[() => false]"
          step="5"
          v-else-if="step_five == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-snackbar v-model="snackbar" :multi-line="mode" :right="x" :top="y">
          {{ snackbar_text }}
          <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-stepper-content step="1">
          <form @submit.prevent="StepOne">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>National Identification Number</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.national_id"
                    :error-messages="errors.national_id"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Training Institution Registration/Admission Number</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.institution_admission_number"
                    :error-messages="errors.institution_admission_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Training Institution</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    item-text="name"
                    item-value="id"
                    :items="training_institutions"
                    v-model="register.training_institution"
                    label="Select"
                    color="lime"
                    :menu-props="{ maxHeight: '400' }"
                    persistent-hint
                    :error-messages="errors.training_institution"
                  ></v-autocomplete>
                </v-flex>
                <!--<v-flex xs12 md12>
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="register.admission_year"
                      label="Year of Admission"
                      color="lime"
                      prepend-icon="event"
                      readonly
                      :error-messages="errors.admission_year"
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="register.admission_year"
                      @input="save"
                      reactive
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-flex>-->
                <v-flex xs12 md12>
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="register.admission_year"
                      label="Date of Admission"
                      color="lime"
                      prepend-icon="event"
                      readonly
                      :error-messages="errors.admission_year"
                    ></v-text-field>
                    <v-date-picker
                      v-model="register.admission_year"
                      color="lime"
                      header-color="lime"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Course</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-radio-group
                    v-model="register.course"
                    wrap
                    :error-messages="errors.course"
                  >
                    <v-radio label="DEGREE" value="1" color="lime"></v-radio>
                    <v-radio label="DIPLOMA" value="2" color="lime"></v-radio>
                    <v-radio
                      label="CERTIFICATE"
                      value="3"
                      color="lime"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12 mt-3>
                  <h4>
                    Upgrading Examination Subjects (Only choose the subjects you
                    did not meet the KNDI cluster subject requirements.)
                  </h4>
                </v-flex>
                <v-alert :value="error_alert_value" type="error"
                  >Please choose an Upgrading Examination Subject below</v-alert
                >
                <v-layout row>
                  <v-flex xs12 md6>
                    <v-checkbox
                      v-model="register.chemistry"
                      color="lime"
                      label="Chemistry"
                    ></v-checkbox>
                    <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_one"
                      label="Subject One"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_one"
                    ></v-autocomplete>-->
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      item-text="name"
                      item-value="id"
                      :items="e_qualifications"
                      v-model="register.chemistry_qualification"
                      label="Chemistry Grade"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.chemistry_qualification"
                      append-outer-icon="clear"
                      @click:append-outer="clearN('chemistry')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 md6>
                    <v-checkbox
                      v-model="register.biology"
                      color="lime"
                      label="Biology"
                    ></v-checkbox>
                    <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_two"
                      label="Subject Two"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_two"
                    ></v-autocomplete>-->
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      item-text="name"
                      item-value="id"
                      :items="e_qualifications"
                      v-model="register.biology_qualification"
                      label="Biology Grade"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.biology_qualification"
                      append-outer-icon="clear"
                      @click:append-outer="clearN('biology')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 md6>
                    <v-checkbox
                      v-model="register.english"
                      color="lime"
                      label="English"
                    ></v-checkbox>
                    <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_three"
                      label="Subject Three"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_three"
                    ></v-autocomplete>-->
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      item-text="name"
                      item-value="id"
                      :items="e_qualifications"
                      v-model="register.english_qualification"
                      label="English Grade"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.english_qualification"
                      append-outer-icon="clear"
                      @click:append-outer="clearN('english')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row mb-3>
                  <v-flex xs12 md6>
                    <v-checkbox
                      v-model="register.mathematics"
                      color="lime"
                      label="Mathematics"
                    ></v-checkbox>
                    <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_four"
                      label="Subject Four"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_four"
                    ></v-autocomplete>-->
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      item-text="name"
                      item-value="id"
                      :items="e_qualifications"
                      v-model="register.mathematics_qualification"
                      label="Mathematics Grade"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.mathematics_qualification"
                      append-outer-icon="clear"
                      @click:append-outer="clearN('mathematics')"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <!-- KCSE Grade Declaration -->
                <v-flex xs12 md12 mt-3>
                  <h4>Declare Your KCSE Grades</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-alert
                    :value="true"
                    type="info"
                    color="lime darken-3"
                    outline
                    class="mb-2"
                  >
                    Enter your KCSE grade for each subject below. If you already
                    meet the requirement via an alternative (e.g. Kiswahili
                    satisfies English), you cannot apply for that upgrading
                    subject.
                  </v-alert>
                </v-flex>

                <v-flex xs12 md12
                  ><small><b>Chemistry Group</b></small></v-flex
                >
                <v-layout row wrap>
                  <v-flex xs12 md6 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.chemistry_grade"
                      label="Chemistry"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.physical_sciences_grade"
                      label="Physical Sciences"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-flex xs12 md12
                  ><small><b>Biology Group</b></small></v-flex
                >
                <v-layout row wrap>
                  <v-flex xs12 md6 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.biology_grade"
                      label="Biology"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.biological_sciences_grade"
                      label="Biological Sciences"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-flex xs12 md12
                  ><small><b>English Group</b></small></v-flex
                >
                <v-layout row wrap>
                  <v-flex xs12 md6 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.english_grade"
                      label="English"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.kiswahili_grade"
                      label="Kiswahili"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-flex xs12 md12
                  ><small><b>4th Subject Group</b></small></v-flex
                >
                <v-layout row wrap>
                  <v-flex xs12 md4 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.mathematics_grade"
                      label="Mathematics"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.geography_grade"
                      label="Geography"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.physics_grade"
                      label="Physics"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="register.course != '1'">
                  <v-flex xs12 md6 pr-2>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.home_science_grade"
                      label="Home Science"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="kcse_grades"
                      item-text="name"
                      item-value="id"
                      v-model="register.agriculture_grade"
                      label="Agriculture"
                      color="lime"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-alert
                  :value="blockedSubjects.length > 0"
                  type="warning"
                  class="mt-2"
                >
                  <div v-for="b in blockedSubjects" :key="b.subject">
                    <b>{{
                      b.subject.charAt(0).toUpperCase() + b.subject.slice(1)
                    }}</b
                    >: {{ b.reason }}
                  </div>
                </v-alert>

                <v-flex xs12 md12 mt-2>
                  <v-checkbox
                    v-model="register.grade_declaration"
                    color="lime"
                    label="I confirm that the KCSE grades I have entered above are correct and match my KCSE certificate. I understand that misrepresentation is grounds for disqualification."
                  ></v-checkbox>
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepOne"
              v-if="disabled == false"
              >continue</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; checking
            </v-btn>
          </form>
        </v-stepper-content>

        <v-stepper-content step="2">
          <form @submit.prevent="StepTwo">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>Surname</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.sname"
                    :error-messages="errors.sname"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>First name</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.fname"
                    :error-messages="errors.fname"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Middle name</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.mname"
                    :error-messages="errors.mname"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="register.dob"
                      label="Date of Birth"
                      color="lime"
                      prepend-icon="event"
                      readonly
                      :error-messages="errors.dob"
                    ></v-text-field>
                    <v-date-picker
                      v-model="register.dob"
                      color="lime"
                      header-color="lime"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Phone Number</h4>
                  <h4 class="subheading .font-weight-thin">
                    (should be in 07xxxxxx or 01xxxxxx format only)
                  </h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.phone_number"
                    :error-messages="errors.phone_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Email</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.email"
                    :error-messages="errors.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Gender</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    item-text="name"
                    item-value="id"
                    :items="gender"
                    v-model="register.gender"
                    color="lime"
                    :menu-props="{ maxHeight: '400' }"
                    persistent-hint
                    :error-messages="errors.gender"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>County</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    item-text="name"
                    item-value="id"
                    :items="counties"
                    v-model="register.county"
                    color="lime"
                    :menu-props="{ maxHeight: '400' }"
                    persistent-hint
                    :error-messages="errors.county"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Postal Address</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.address"
                    :error-messages="errors.address"
                  ></v-text-field>
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepTwo"
              v-if="disabled == false"
              >Continue</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; checking
            </v-btn>
            <v-btn flat color="lime" @click="e1 = 1" :disabled="disabled"
              >back</v-btn
            >
          </form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <form @submit.prevent="StepThree">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>Training Institution Admission Letter</h4>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Click to upload"
                    v-model="file_name_a"
                    :error-messages="errors.file_a"
                    @click="onPickFileA"
                    color="lime"
                    prepend-icon="attach_file"
                    readonly
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputA"
                    id="fileInputA"
                    @change="onFilePickedA"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepThree"
              v-if="disabled == false"
              >continue</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; checking
            </v-btn>
            <v-btn flat color="lime" @click="e1 = 2" :disabled="disabled"
              >back</v-btn
            >
          </form>
        </v-stepper-content>
        <v-stepper-content step="4">
          <form @submit.prevent="StepFour">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>K.C.S.E Certificate</h4>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Click to upload"
                    v-model="file_name_k"
                    :error-messages="errors.file_k"
                    @click="onPickFileK"
                    color="lime"
                    prepend-icon="attach_file"
                    readonly
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputK"
                    id="fileInputK"
                    @change="onFilePickedK"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepFour"
              v-if="disabled == false"
              >continue</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; checking
            </v-btn>
            <v-btn flat color="lime" @click="e1 = 3" :disabled="disabled"
              >back</v-btn
            >
          </form>
        </v-stepper-content>
        <v-stepper-content step="5">
          <form @submit.prevent="StepFive">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>Student Agreement Form</h4>
                  <div>
                    This form is supposed to be downloaded, physically filled
                    and scanned before uploading. Follow this link to download
                    it
                    <a
                      href="https://www.kndi.institute/exams/student_agreement_form.pdf"
                      target="_blank"
                      >click here</a
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Click to upload"
                    v-model="file_name_s"
                    :error-messages="errors.file_s"
                    @click="onPickFileS"
                    color="lime"
                    prepend-icon="attach_file"
                    readonly
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputS"
                    id="fileInputS"
                    @change="onFilePickedS"
                  />
                </v-flex>
                <!--
                  Added 29 Sep. file_upload() has accepted identification_document
                  since this form was first built - it has its own branch there -
                  but no client control ever sent it, so nobody has ever actually
                  been asked for this document. Made mandatory for new applications
                  from 29 Sep; existing applicants are still not chased for it
                  retroactively (the completeness guards on assess() and
                  set_status_exam_card() do not check it).
                -->
                <v-flex xs12 md12>
                  <h4>National ID or Birth Certificate</h4>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Click to upload"
                    v-model="file_name_id"
                    :error-messages="errors.file_id"
                    @click="onPickFileId"
                    color="lime"
                    prepend-icon="attach_file"
                    append-outer-icon="clear"
                    @click:append-outer="clearId"
                    readonly
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputId"
                    id="fileInputId"
                    @change="onFilePickedId"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepFive"
              v-if="disabled == false"
              >submit</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; submitting
            </v-btn>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Processing
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!---<v-dialog v-model="closed" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          THIS APPLICATION IS NOW CLOSED
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>-->
    <v-dialog v-model="dialog_resit" persistent width="800">
      <v-card>
        <v-card-title>
          <div>Professional Upgrading Resit</div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-progress-linear
                :indeterminate="true"
                color="lime"
                v-if="sending"
              ></v-progress-linear>
              <v-flex xs12 md12>
                <h4>Phone Number</h4>
                <h4 class="subheading .font-weight-thin">
                  (should be in 07xxxxxx or 01xxxxxx format only)
                </h4>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  class="input-group--focused"
                  color="lime"
                  v-model="register.phone_number"
                  :error-messages="errors.phone_number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <h4>Email</h4>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  class="input-group--focused"
                  color="lime"
                  v-model="register.email"
                  :error-messages="errors.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <h4>Student Agreement Form</h4>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Click to upload"
                  v-model="file_name_s"
                  :error-messages="errors.file_s"
                  @click="onPickFileS"
                  color="lime"
                  prepend-icon="attach_file"
                  readonly
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="fileInputS"
                  id="fileInputS"
                  @change="onFilePickedS"
                />
              </v-flex>
              <v-flex xs12 md12 mt-3>
                <h4>
                  Resit Upgrading Examination Subjects (Only choose the subjects
                  you are supposed to Resit.)
                </h4>
              </v-flex>
              <v-alert :value="error_alert_value" type="error"
                >Please choose a Resit Upgrading Examination Subject
                below</v-alert
              >
            </v-layout>
            <v-layout row>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.chemistry"
                  color="lime"
                  label="Chemistry"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_one"
                      label="Subject One"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_one"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.chemistry_qualification"
                  label="Chemistry Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.chemistry_qualification"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('chemistry')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.biology"
                  color="lime"
                  label="Biology"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_two"
                      label="Subject Two"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_two"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.biology_qualification"
                  label="Biology Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.biology_qualification"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('biology')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.english"
                  color="lime"
                  label="English"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_three"
                      label="Subject Three"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_three"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.english_qualification"
                  label="English Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.english_qualification"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('english')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row mb-3>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.mathematics"
                  color="lime"
                  label="Mathematics"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_four"
                      label="Subject Four"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_four"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.mathematics_qualification"
                  label="Mathematics Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.mathematics_qualification"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('mathematics')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-flex xs12 md12 mt-3>
              <h4>
                Are there First Time Upgrading Examination Subjects you are yet
                to sit for?
              </h4>
              <v-flex xs12 md12>
                <v-radio-group
                  v-model="register.first_time"
                  wrap
                  :error-messages="first_time"
                >
                  <v-radio label="YES" value="1" color="lime"></v-radio>
                  <v-radio label="NO" value="2" color="lime"></v-radio>
                </v-radio-group>
              </v-flex>
              <h4 v-if="register.first_time == '1'">
                First Time Upgrading Examination Subjects (Only choose the
                subjects you are supposed to sit for but you have never taken.)
              </h4>
            </v-flex>
            <v-layout row v-if="register.first_time == '1'">
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.chemistry_first"
                  color="lime"
                  label="Chemistry"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_one"
                      label="Subject One"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_one"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.chemistry_qualification_first"
                  label="Chemistry Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.chemistry_qualification_first"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('chemistry_first')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row v-if="register.first_time == '1'">
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.biology_first"
                  color="lime"
                  label="Biology"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_two"
                      label="Subject Two"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_two"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.biology_qualification_first"
                  label="Biology Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.biology_qualification_first"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('biology_first')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row v-if="register.first_time == '1'">
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.english_first"
                  color="lime"
                  label="English"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_three"
                      label="Subject Three"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_three"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.english_qualification_first"
                  label="English Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.english_qualification_first"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('english_first')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row mb-3 v-if="register.first_time == '1'">
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="register.mathematics_first"
                  color="lime"
                  label="Mathematics"
                ></v-checkbox>
                <!--<v-autocomplete
                      class="pr-2"
                      item-text="name"
                      item-value="id"
                      :items="e_subjects"
                      v-model="register.subject_four"
                      label="Subject Four"
                      color="lime"
                      :menu-props="{ maxHeight: '400' }"
                      persistent-hint
                      :error-messages="errors.subject_four"
                    ></v-autocomplete>-->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  item-text="name"
                  item-value="id"
                  :items="e_qualifications"
                  v-model="register.mathematics_qualification_first"
                  label="Mathematics Grade"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.mathematics_qualification_first"
                  append-outer-icon="clear"
                  @click:append-outer="clearN('mathematics_first')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="lime darken-1"
            flat
            @click.native="ResitSubmit"
            :disabled="disabled"
            >SUBMIT</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="check_resit" truestent width="600" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-progress-linear
                :indeterminate="true"
                color="lime"
                v-if="sending"
              ></v-progress-linear>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="register.national_id"
                  :error-messages="errors.national_id"
                  label="National Identification Number"
                  color="lime"
                  counter="70"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-autocomplete
                  class="pr-2"
                  item-text="name"
                  item-value="id"
                  :items="exam_periods"
                  v-model="register.exam_period"
                  label="Exam period"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.exam_period"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-autocomplete
                  class="pr-2"
                  item-text="name"
                  item-value="id"
                  :items="choices"
                  v-model="choice"
                  label="Exam Entry"
                  color="lime"
                  :menu-props="{ maxHeight: '400' }"
                  persistent-hint
                  :error-messages="errors.choice"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="lime darken-1"
            flat
            @click.native="first_step"
            :disabled="disabled"
            >CHECK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from "vue"
import {
  upgradeExamRegisterUrl,
  upgradeExamResitRegisterUrl,
  upgrading_exam_file_uploadUrl,
  upgrading_exam_stepper_one_dataUrl,
  upgrading_exam_stepper_one_check_one_Url,
  upgrading_exam_stepper_one_check_two_Url,
  upgrading_exam_stepper_resit_check_Url
} from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      error_alert_value: false,
      y: "",
      x: "",
      mode: "",
      menu: false,
      menu2: false,
      e1: 0,
      eStepOne: 0,
      e3: false,
      e4: false,
      e6: 1,
      dialog_terms: false,
      maxCount: 140,
      remainingCount: 140,
      checking: false,
      disabled: false,
      step_two: true,
      step_one: true,
      step_three: true,
      step_four: true,
      step_five: true,
      dialog_loading: false,
      file_name_a: "",
      file_name_k: "",
      file_name_s: "",
      file_name_id: "",
      register: {
        email: "",
        national_id: "",
        phone_number: "",
        admission_year: "",
        fname: "",
        sname: "",
        mname: "",
        dob: "",
        gender: "",
        county: "",
        address: "",
        exam_period: "",
        training_institution: "",
        institution_admission_number: "",
        chemistry: "",
        biology: "",
        english: "",
        mathematics: "",
        chemistry_qualification: "",
        biology_qualification: "",
        english_qualification: "",
        mathematics_qualification: "",
        chemistry_first: "",
        biology_first: "",
        english_first: "",
        mathematics_first: "",
        chemistry_qualification_first: "",
        biology_qualification_first: "",
        english_qualification_first: "",
        mathematics_qualification_first: "",
        high_school_grade: "",
        course: "",
        file_a: "",
        file_k: "",
        file_s: "",
        file_id: "",
        first_time: "",
        chemistry_grade: "",
        physical_sciences_grade: "",
        biology_grade: "",
        biological_sciences_grade: "",
        english_grade: "",
        kiswahili_grade: "",
        mathematics_grade: "",
        geography_grade: "",
        physics_grade: "",
        home_science_grade: "",
        agriculture_grade: "",
        grade_declaration: false
      },
      errors: {
        email: "",
        national_id: "",
        phone_number: "",
        admission_year: "",
        fname: "",
        sname: "",
        dob: "",
        gender: "",
        county: "",
        address: "",
        exam_period: "",
        training_institution: "",
        institution_admission_number: "",
        chemistry: "",
        biology: "",
        english: "",
        mathematics: "",
        chemistry_qualification: "",
        biology_qualification: "",
        english_qualification: "",
        mathematics_qualification: "",
        high_school_grade: "",
        course: "",
        file_a: "",
        file_k: "",
        file_s: "",
        file_id: "",
        choice: "",
        first_time: ""
      },
      errors_dialog: {},
      dialog: false,
      sending: false,
      training_institutions: [],
      counties: [],
      gender: [],
      token: "",
      e_qualifications: [
        {
          id: 1,
          name: "A"
        },
        {
          id: 2,
          name: "A -"
        },
        {
          id: 3,
          name: "B +"
        },
        {
          id: 4,
          name: "B"
        },
        {
          id: 5,
          name: "B -"
        },
        {
          id: 6,
          name: "C +"
        },
        {
          id: 7,
          name: "C"
        },
        {
          id: 8,
          name: "C -"
        },
        {
          id: 9,
          name: "D +"
        },
        {
          id: 10,
          name: "D"
        },
        {
          id: 11,
          name: "D -"
        },
        {
          id: 12,
          name: "E"
        }
      ],
      kcse_grades: [
        { id: "A", name: "A" },
        { id: "A-", name: "A-" },
        { id: "B+", name: "B+" },
        { id: "B", name: "B" },
        { id: "B-", name: "B-" },
        { id: "C+", name: "C+" },
        { id: "C", name: "C" },
        { id: "C-", name: "C-" },
        { id: "D+", name: "D+" },
        { id: "D", name: "D" },
        { id: "D-", name: "D-" },
        { id: "E", name: "E" }
      ],
      choice: "",
      choices: [
        {
          id: 1,
          name: "First time"
        },
        {
          id: 2,
          name: "Resit"
        }
      ],
      exam_periods: [],
      check_grade: false,
      closed: false,
      check_resit: false,
      dialog_resit: false,
      app_tbl_id: ""
    }
  },
  computed: {
    blockedSubjects() {
      const gradePoints = {
        A: 12,
        "A-": 11,
        "B+": 10,
        B: 9,
        "B-": 8,
        "C+": 7,
        C: 6,
        "C-": 5,
        "D+": 4,
        D: 3,
        "D-": 2,
        E: 1
      }
      const subjectGroups = {
        CERTIFICATE: {
          chemistry: ["chemistry", "physical_sciences"],
          biology: ["biology", "biological_sciences"],
          english: ["english", "kiswahili"],
          mathematics: [
            "mathematics",
            "physics",
            "home_science",
            "agriculture"
          ]
        },
        DIPLOMA: {
          chemistry: ["chemistry", "physical_sciences"],
          biology: ["biology", "biological_sciences"],
          english: ["english", "kiswahili"],
          mathematics: [
            "mathematics",
            "physics",
            "home_science",
            "agriculture"
          ]
        },
        DEGREE: {
          chemistry: ["chemistry", "physical_sciences"],
          biology: ["biology", "biological_sciences"],
          english: ["english", "kiswahili"],
          mathematics: ["mathematics", "geography", "physics"]
        }
      }
      const thresholds = {
        CERTIFICATE: {
          chemistry: "D",
          biology: "D",
          english: "D",
          mathematics: "D"
        },
        DIPLOMA: {
          chemistry: "D+",
          biology: "D+",
          english: "D+",
          mathematics: "D"
        },
        DEGREE: { chemistry: "C", biology: "C", english: "C", mathematics: "C" }
      }
      const levelMap = { "1": "DEGREE", "2": "DIPLOMA", "3": "CERTIFICATE" }
      const level = levelMap[this.register.course] || "CERTIFICATE"
      const grades = {
        chemistry: this.register.chemistry_grade,
        physical_sciences: this.register.physical_sciences_grade,
        biology: this.register.biology_grade,
        biological_sciences: this.register.biological_sciences_grade,
        english: this.register.english_grade,
        kiswahili: this.register.kiswahili_grade,
        mathematics: this.register.mathematics_grade,
        geography: this.register.geography_grade,
        physics: this.register.physics_grade,
        home_science: this.register.home_science_grade,
        agriculture: this.register.agriculture_grade
      }
      const selected = [
        "chemistry",
        "biology",
        "english",
        "mathematics"
      ].filter(s => this.register[s] !== "")
      const blocked = []
      const levelGroups = subjectGroups[level] || {}
      const levelThresholds = thresholds[level] || {}
      for (const subject of selected) {
        const group = levelGroups[subject]
        const threshold = levelThresholds[subject]
        if (!group || !threshold) continue
        const required = gradePoints[threshold]
        for (const alt of group) {
          const grade = grades[alt]
          if (grade && gradePoints[grade] >= required) {
            const altLabel = alt
              .replace(/_/g, " ")
              .replace(/\b\w/g, l => l.toUpperCase())
            const subjLabel = subject.charAt(0).toUpperCase() + subject.slice(1)
            blocked.push({
              subject,
              reason: `Your ${altLabel} grade of ${grade} satisfies the ${subjLabel} requirement at ${level} level.`
            })
            break
          }
        }
      }
      return blocked
    }
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
    },
    "register.first_time"(newValue, oldValue) {
      if (newValue === 2 && oldValue !== 2) {
        // Reset fields only when the value changes to 2
        this.setFtime()
      }
    },
    // Watch chemistry-related fields
    "register.chemistry_first"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("chemistry_first")
      }
    },
    "register.chemistry"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("chemistry")
      }
    },

    // Watch biology-related fields
    "register.biology_first"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("biology_first")
      }
    },
    "register.biology"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("biology")
      }
    },

    // Watch english-related fields
    "register.english_first"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("english_first")
      }
    },
    "register.english"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("english")
      }
    },

    // Watch mathematics-related fields
    "register.mathematics_first"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("mathematics_first")
      }
    },
    "register.mathematics"(newValue, oldValue) {
      if (newValue) {
        this.checkFT("mathematics")
      }
    }
  },
  beforeMount() {
    this.fetchData()
    this.dialog = true
    this.closed = true
    //this.check_resit = true
  },
  methods: {
    setFtime() {
      var vm = this
      vm.register.chemistry_first = ""
      vm.register.chemistry_qualification_first = ""
      vm.register.biology_first = ""
      vm.register.biology_qualification_first = ""
      vm.register.mathematics_first = ""
      vm.register.mathematics_qualification_first = ""
      vm.register.english_first = ""
      vm.register.english_qualification_first = ""
    },
    clearN(item) {
      var vm = this
      if (item == "chemistry") {
        vm.register.chemistry = ""
        vm.register.chemistry_qualification = ""
      }
      if (item == "biology") {
        vm.register.biology = ""
        vm.register.biology_qualification = ""
      }
      if (item == "english") {
        vm.register.english = ""
        vm.register.english_qualification = ""
      }
      if (item == "mathematics") {
        vm.register.mathematics = ""
        vm.register.mathematics_qualification = ""
      }
      if (item == "chemistry_first") {
        vm.register.chemistry_first = ""
        vm.register.chemistry_qualification_first = ""
      }
      if (item == "biology_first") {
        vm.register.biology_first = ""
        vm.register.biology_qualification_first = ""
      }
      if (item == "english_first") {
        vm.register.english_first = ""
        vm.register.english_qualification_first = ""
      }
      if (item == "mathematics_first") {
        vm.register.mathematics_first = ""
        vm.register.mathematics_qualification_first = ""
      }
    },
    checkFT(item) {
      var vm = this
      if (item == "chemistry") {
        vm.register.chemistry_first = ""
        vm.register.chemistry_qualification_first = ""
      }
      if (item == "biology") {
        vm.register.biology_first = ""
        vm.register.biology_qualification_first = ""
      }
      if (item == "english") {
        vm.register.english_first = ""
        vm.register.english_qualification_first = ""
      }
      if (item == "mathematics") {
        vm.register.mathematics_first = ""
        vm.register.mathematics_qualification_first = ""
      }
      if (item == "chemistry_first") {
        vm.register.chemistry = ""
        vm.register.chemistry_qualification = ""
      }
      if (item == "biology_first") {
        vm.register.biology = ""
        vm.register.biology_qualification = ""
      }
      if (item == "english_first") {
        vm.register.english = ""
        vm.register.english_qualification = ""
      }
      if (item == "mathematics_first") {
        vm.register.mathematics = ""
        vm.register.mathematics_qualification = ""
      }
    },
    onPickFileA() {
      var vm = this
      vm.$refs.fileInputA.click()
    },
    onFilePickedA(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.register.file_a = e.target.result
        vm.file_name_a = file.name
        //console.log(vm.file_name_c)
      }
    },
    onPickFileK() {
      var vm = this
      vm.$refs.fileInputK.click()
    },
    onFilePickedK(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.register.file_k = e.target.result
        vm.file_name_k = file.name
        //console.log(vm.file_name_c)
      }
    },
    onPickFileS() {
      var vm = this
      vm.$refs.fileInputS.click()
    },
    onFilePickedS(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.register.file_s = e.target.result
        vm.file_name_s = file.name
        //console.log(vm.file_name_c)
      }
    },
    onPickFileId() {
      var vm = this
      vm.$refs.fileInputId.click()
    },
    onFilePickedId(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.register.file_id = e.target.result
        vm.file_name_id = file.name
      }
    },
    // Optional field, so it gets a clear button the required ones do not - an
    // applicant who picked the wrong file, or changed their mind about supplying
    // it at all, can empty it without reloading the page.
    clearId() {
      var vm = this
      vm.register.file_id = ""
      vm.file_name_id = ""
      vm.errors.file_id = ""
    },
    save(date) {
      this.$refs.picker.activePicker = "YEAR"
      this.menu = false
      var save_var = date.substring(0, 4)
      this.$refs.menu.save(save_var)
      this.register.admission_year = save_var
      //console.log(save_var)
    },
    fetchData() {
      var vm = this
      axios
        .get(upgrading_exam_stepper_one_dataUrl)
        .then(function(response) {
          Vue.set(
            vm.$data,
            "training_institutions",
            response.data.training_institutions
          )
          Vue.set(vm.$data, "counties", response.data.counties)
          Vue.set(vm.$data, "gender", response.data.gender)
          Vue.set(vm.$data, "token", response.data.token)
          Vue.set(vm.$data, "exam_periods", response.data.exam_periods)
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    first_step() {
      var vm = this
      if (vm.choice == "") {
        vm.errors.choice = "Please pick an Exam Entry"
      } else {
        if (vm.choice == 1) {
          swal({
            title: "Checked",
            text: "You can proceed with your upgrading examination application",
            type: "success",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
          //vm.errors.national_id = ""
          vm.dialog_loading = false
          vm.check_resit = false
        } else {
          vm.checkResit()
        }
      }
    },
    checkResit() {
      var vm = this
      vm.dialog_loading = true
      const data = {
        national_id: vm.register.national_id,
        exam_period: vm.register.exam_period
      }
      axios
        .post(upgrading_exam_stepper_resit_check_Url, data)
        .then(function(response) {
          vm.errors.national_id = ""
          if (response.data.checked) {
            swal({
              title: "Checked",
              text: "You are not eligible for Exam Resit.",
              type: "info",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.errors.national_id = ""
            vm.dialog_loading = false
            //vm.check_resit = false
          } else if (response.data.duplicate) {
            swal({
              title: "Duplicate",
              text:
                "We have already received your upgrading examination application",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.dialog_loading = false
          } else if (response.data.resit) {
            vm.dialog_loading = false
            swal({
              title: "Resit",
              text:
                "Do you want to apply for a resit of your upgrading examination application?",
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#CDDC39",
              cancelButtonColor: "#F44336",
              confirmButtonText: "Resit",
              cancelButtonText: "Cancel"
            }).then(result => {
              if (result.value) {
                vm.check_resit = false
                vm.dialog_resit = true
                Vue.set(vm.$data, "app_tbl_id", response.data.app_tbl_id)
              } else if (
                // Read more about handling dismissals
                result.dismiss === "cancel"
              ) {
                swal({
                  title: "Cancelled",
                  text: "Application was cancelled",
                  type: "error",
                  confirmButtonColor: "#cddc39",
                  confirmButtonText: "OK"
                })
                vm.disabled = false
                //vm.closeCreate()
              }
            })
          }
        })
        .catch(function(error) {
          console.log(error)
          vm.dialog_loading = false
          vm.errors.national_id = error.response.data.national_id
          vm.errors.exam_period = error.response.data.exam_period
          vm.disabled = false
          vm.dialog_loading = false
          //vm.step_one = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    ResitSubmit() {
      var vm = this
      vm.disabled = true

      // Create data object with the new _first fields
      const data = {
        phone_number: vm.register.phone_number,
        exam_period: vm.register.exam_period,
        national_id: vm.register.national_id,
        email: vm.register.email,
        student_agreement_form: vm.register.file_s,
        app_tbl_id: vm.app_tbl_id,
        chemistry: vm.register.chemistry,
        biology: vm.register.biology,
        english: vm.register.english,
        mathematics: vm.register.mathematics,
        chemistry_qualification: vm.register.chemistry_qualification,
        biology_qualification: vm.register.biology_qualification,
        english_qualification: vm.register.english_qualification,
        mathematics_qualification: vm.register.mathematics_qualification,
        chemistry_first: vm.register.chemistry_first, // Added _first fields
        biology_first: vm.register.biology_first,
        english_first: vm.register.english_first,
        mathematics_first: vm.register.mathematics_first,
        chemistry_qualification_first:
          vm.register.chemistry_qualification_first, // Added _first fields
        biology_qualification_first: vm.register.biology_qualification_first,
        english_qualification_first: vm.register.english_qualification_first,
        mathematics_qualification_first:
          vm.register.mathematics_qualification_first
      }

      // Check if any subject is selected
      if (
        vm.register.chemistry == "" &&
        vm.register.biology == "" &&
        vm.register.english == "" &&
        vm.register.mathematics == ""
      ) {
        vm.error_alert_value = true
        vm.disabled = false
      } else {
        vm.error_alert_value = false
      }

      // If any subject is selected, check for missing qualifications
      if (
        vm.register.chemistry != "" ||
        vm.register.biology != "" ||
        vm.register.english != "" ||
        vm.register.mathematics != ""
      ) {
        if (
          vm.register.chemistry_qualification == "" &&
          vm.register.chemistry != ""
        ) {
          vm.errors.chemistry_qualification =
            "Please fill in your Chemistry Grade"
        } else {
          vm.errors.chemistry_qualification = ""
        }
        if (
          vm.register.biology_qualification == "" &&
          vm.register.biology != ""
        ) {
          vm.errors.biology_qualification = "Please fill in your Biology Grade"
        } else {
          vm.errors.biology_qualification = ""
        }
        if (
          vm.register.english_qualification == "" &&
          vm.register.english != ""
        ) {
          vm.errors.english_qualification = "Please fill in your English Grade"
        } else {
          vm.errors.english_qualification = ""
        }
        if (
          vm.register.mathematics_qualification == "" &&
          vm.register.mathematics != ""
        ) {
          vm.errors.mathematics_qualification =
            "Please fill in your Mathematics Grade"
        } else {
          vm.errors.mathematics_qualification = ""
        }

        // Check for missing qualifications in _first fields
        if (
          vm.register.chemistry_qualification_first == "" &&
          vm.register.chemistry_first != ""
        ) {
          vm.errors.chemistry_qualification_first =
            "Please fill in your Chemistry Grade (First)"
        } else {
          vm.errors.chemistry_qualification_first = ""
        }
        if (
          vm.register.biology_qualification_first == "" &&
          vm.register.biology_first != ""
        ) {
          vm.errors.biology_qualification_first =
            "Please fill in your Biology Grade (First)"
        } else {
          vm.errors.biology_qualification_first = ""
        }
        if (
          vm.register.english_qualification_first == "" &&
          vm.register.english_first != ""
        ) {
          vm.errors.english_qualification_first =
            "Please fill in your English Grade (First)"
        } else {
          vm.errors.english_qualification_first = ""
        }
        if (
          vm.register.mathematics_qualification_first == "" &&
          vm.register.mathematics_first != ""
        ) {
          vm.errors.mathematics_qualification_first =
            "Please fill in your Mathematics Grade (First)"
        } else {
          vm.errors.mathematics_qualification_first = ""
        }

        // If any qualification is missing, enable submit button
        if (
          (vm.register.chemistry_qualification == "" &&
            vm.register.chemistry != "") ||
          (vm.register.biology_qualification == "" &&
            vm.register.biology != "") ||
          (vm.register.english_qualification == "" &&
            vm.register.english != "") ||
          (vm.register.mathematics_qualification == "" &&
            vm.register.mathematics != "") ||
          (vm.register.chemistry_qualification_first == "" &&
            vm.register.chemistry_first != "") ||
          (vm.register.biology_qualification_first == "" &&
            vm.register.biology_first != "") ||
          (vm.register.english_qualification_first == "" &&
            vm.register.english_first != "") ||
          (vm.register.mathematics_qualification_first == "" &&
            vm.register.mathematics_first != "")
        ) {
          vm.disabled = false
        } else {
          vm.dialog_loading = true
          axios
            .post(upgradeExamResitRegisterUrl, data)
            .then(function(response) {
              if (response.data.stored) {
                // Clear all fields upon successful submission
                vm.register.chemistry = ""
                vm.register.biology = ""
                vm.register.english = ""
                vm.register.mathematics = ""
                vm.register.chemistry_qualification = ""
                vm.register.biology_qualification = ""
                vm.register.english_qualification = ""
                vm.register.mathematics_qualification = ""
                vm.register.chemistry_first = ""
                vm.register.biology_first = ""
                vm.register.english_first = ""
                vm.register.mathematics_first = ""
                vm.register.chemistry_qualification_first = ""
                vm.register.biology_qualification_first = ""
                vm.register.english_qualification_first = ""
                vm.register.mathematics_qualification_first = ""
                vm.errors.chemistry = ""
                vm.errors.biology = ""
                vm.errors.english = ""
                vm.errors.mathematics = ""
                vm.errors.chemistry_qualification = ""
                vm.errors.biology_qualification = ""
                vm.errors.english_qualification = ""
                vm.errors.mathematics_qualification = ""
                vm.errors.chemistry_qualification_first = ""
                vm.errors.biology_qualification_first = ""
                vm.errors.english_qualification_first = ""
                vm.errors.mathematics_qualification_first = ""
                vm.errors.phone_number = ""
                vm.errors.email = ""
                vm.errors.national_id = ""
                vm.register.file_s = ""
                vm.register.national_id = ""
                vm.register.phone_number = ""
                vm.register.email = ""
                vm.file_name_s = ""
                vm.dialog_resit = false
                vm.check_resit = true
                vm.dialog_loading = false
                swal({
                  title: "Success",
                  text:
                    "Please check your email right now for further instructions",
                  type: "success",
                  confirmButtonColor: "#cddc39",
                  confirmButtonText: "OK"
                })
                vm.$router.push({ name: "upgrading-examination-register" })
              } else if (response.data.file_error) {
                swal({
                  title: "File error",
                  text: "Please upload PDF, JPG or PNG Format only",
                  type: "warning",
                  confirmButtonColor: "#cddc39",
                  confirmButtonText: "OK"
                })
                vm.disabled = false
                vm.dialog_loading = false
              } else if (response.data.past_time) {
                swal({
                  title:
                    "Passed Date for the Following Subjects In this Exam Period: " +
                    response.data.past_time_subjects,
                  text: "",
                  type: "error",
                  confirmButtonColor: "#cddc39",
                  confirmButtonText: "OK"
                })
                vm.disabled = false
                vm.dialog_loading = false
              } else if (response.data.grade_blocked) {
                const reasons = response.data.grade_blocked_subjects
                  .map(b => b.reason)
                  .join("\n")
                swal({
                  title: "Subject Not Required",
                  text: reasons,
                  type: "warning",
                  confirmButtonColor: "#cddc39",
                  confirmButtonText: "OK"
                })
                vm.disabled = false
                vm.dialog_loading = false
              }
            })
            .catch(function(error) {
              console.log(error)
              vm.errors.phone_number = error.response.data.phone_number
              vm.errors.email = error.response.data.email
              vm.dialog_loading = false
              vm.disabled = false
              if (error.message == "Network Error") {
                vm.snackbar_text =
                  "We have detected a slow internet connection! It may interfere with the responsiveness of the KNDI OSP."
                vm.snackbar = true
                vm.x = "right"
                vm.y = "top"
                vm.mode = "multi-line"
              }
            })
        }
      }
    },

    checkNationalId() {
      var vm = this
      const data = {
        national_id: vm.register.national_id,
        exam_period: vm.register.exam_period,
        course: vm.register.course,
        chemistry: vm.register.chemistry,
        biology: vm.register.biology,
        english: vm.register.english,
        mathematics: vm.register.mathematics,
        chemistry_first: vm.register.chemistry_first,
        biology_first: vm.register.biology_first,
        english_first: vm.register.english_first,
        mathematics_first: vm.register.mathematics_first,
        chemistry_grade: vm.register.chemistry_grade,
        physical_sciences_grade: vm.register.physical_sciences_grade,
        biology_grade: vm.register.biology_grade,
        biological_sciences_grade: vm.register.biological_sciences_grade,
        english_grade: vm.register.english_grade,
        kiswahili_grade: vm.register.kiswahili_grade,
        mathematics_grade: vm.register.mathematics_grade,
        geography_grade: vm.register.geography_grade,
        physics_grade: vm.register.physics_grade,
        home_science_grade: vm.register.home_science_grade,
        agriculture_grade: vm.register.agriculture_grade
      }

      axios
        .post(upgrading_exam_stepper_one_check_one_Url, data)
        .then(function(response) {
          if (response.data.checked) {
            vm.errors.national_id = ""
            vm.errors.training_institution = ""
            vm.errors.institution_admission_number = ""
            vm.errors.admission_year = ""
            vm.errors.chemistry = ""
            vm.errors.biology = ""
            vm.errors.english = ""
            vm.errors.mathematics = ""
            vm.errors.chemistry_qualification = ""
            vm.errors.biology_qualification = ""
            vm.errors.english_qualification = ""
            vm.errors.mathematics_qualification = ""
            vm.errors.high_school_grade = ""
            vm.errors.course = ""
            vm.errors.exam_period = ""

            if (vm.errors.national_id == "") {
              vm.disabled = false
              vm.step_one = true
              vm.e1 = 2
            }
          } else if (response.data.duplicate) {
            vm.disabled = false
            vm.errors.national_id = ""
            vm.errors.training_institution = ""
            vm.errors.institution_admission_number = ""
            vm.errors.admission_year = ""
            vm.errors.chemistry = ""
            vm.errors.biology = ""
            vm.errors.english = ""
            vm.errors.mathematics = ""
            vm.errors.chemistry_qualification = ""
            vm.errors.biology_qualification = ""
            vm.errors.english_qualification = ""
            vm.errors.mathematics_qualification = ""
            vm.errors.high_school_grade = ""
            vm.errors.course = ""
            vm.errors.exam_period = ""
            swal({
              title: "Duplicate",
              text:
                "We have already received your upgrading examination application",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          } else if (response.data.p_data_duplicate) {
            vm.disabled = false
            vm.errors.national_id = ""
            vm.errors.training_institution = ""
            vm.errors.institution_admission_number = ""
            vm.errors.admission_year = ""
            vm.errors.chemistry = ""
            vm.errors.biology = ""
            vm.errors.english = ""
            vm.errors.mathematics = ""
            vm.errors.chemistry_qualification = ""
            vm.errors.biology_qualification = ""
            vm.errors.english_qualification = ""
            vm.errors.mathematics_qualification = ""
            vm.errors.high_school_grade = ""
            ;(vm.errors.course = ""), (vm.errors.exam_period = "")
            swal({
              title: "Duplicate",
              text: "You are already registered on the KNDI OSP System",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          } else if (response.data.emory_duplicate) {
            vm.disabled = false
            vm.errors.national_id = ""
            vm.errors.training_institution = ""
            vm.errors.institution_admission_number = ""
            vm.errors.admission_year = ""
            vm.errors.chemistry = ""
            vm.errors.biology = ""
            vm.errors.english = ""
            vm.errors.mathematics = ""
            vm.errors.chemistry_qualification = ""
            vm.errors.biology_qualification = ""
            vm.errors.english_qualification = ""
            vm.errors.mathematics_qualification = ""
            vm.errors.high_school_grade = ""
            vm.errors.course = ""
            swal({
              title: "Duplicate",
              text: "You already have an Index Number.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          } else if (response.data.past_time) {
            swal({
              title:
                "Passed Date for the Following Subjects In this Exam Period: " +
                response.data.past_time_subjects,
              text: "",
              type: "error",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            vm.dialog_loading = false
          }
        })
        .catch(function(error) {
          console.log(error)
          vm.errors.national_id = error.response.data.national_id
          vm.disabled = false
          vm.step_one = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    checkTwo() {
      var vm = this
      const data = {
        phone_number: vm.register.phone_number,
        email: vm.register.email,
        exam_period: vm.register.exam_period
      }

      axios
        .post(upgrading_exam_stepper_one_check_two_Url, data)
        .then(function(response) {
          if (response.data.checked) {
            vm.errors.sname = ""
            vm.errors.fname = ""
            vm.errors.phone_number = ""
            vm.errors.email = ""
            vm.errors.dob = ""
            vm.errors.gender = ""
            vm.errors.county = ""
            vm.errors.address = ""

            if (vm.errors.phone_number == "" && vm.errors.email == "") {
              vm.disabled = false
              vm.step_two = true
              vm.e1 = 3
            }
          }
        })
        .catch(function(error) {
          console.log(error)
          vm.errors.phone_number = error.response.data.phone_number
          vm.errors.email = error.response.data.email
          vm.disabled = false
          vm.step_two = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    StepOne() {
      var vm = this
      vm.disabled = true
      if (
        vm.register.national_id == "" ||
        vm.register.training_institution == "" ||
        vm.register.institution_admission_number == "" ||
        vm.register.admission_year == "" ||
        vm.register.course == "" ||
        (vm.register.chemistry == "" &&
          vm.register.biology == "" &&
          vm.register.english == "" &&
          vm.register.mathematics == "")
      ) {
        if (vm.register.national_id == "") {
          vm.errors.national_id = "Please fill in your national id number"
        } else {
          vm.errors.national_id = ""
        }
        if (vm.register.training_institution == "") {
          vm.errors.training_institution =
            "Please fill in your training institution"
        } else {
          vm.errors.training_institution = ""
        }
        if (vm.register.institution_admission_number == "") {
          vm.errors.institution_admission_number =
            "Please fill in your training institution admission number"
        } else {
          vm.errors.institution_admission_number = ""
        }
        if (vm.register.admission_year == "") {
          vm.errors.admission_year =
            "Please fill in your grade for Admission Year"
        } else {
          vm.errors.admission_year = ""
        }
        if (
          vm.register.chemistry == "" &&
          vm.register.biology == "" &&
          vm.register.english == "" &&
          vm.register.mathematics == ""
        ) {
          vm.error_alert_value = true
        }
        /*if (vm.register.chemistry == "") {
          vm.errors.chemistry = "Please fill in your grade for Chemistry"
        } else {
          vm.errors.chemistry = ""
        }
        if (vm.register.biology == "") {
          vm.errors.biology = "Please fill in your grade for Biology"
        } else {
          vm.errors.biology = ""
        }
        if (vm.register.english_or_kiswahili == "") {
          vm.errors.english_or_kiswahili =
            "Please fill in your grade for either English / Kiswahili"
        } else {
          vm.errors.english_or_kiswahili = ""
        }
        if (vm.register.maths_or_geography_or_physics == "") {
          vm.errors.maths_or_geography_or_physics =
            "Please fill in your grade for either Maths / Geography / Physics"
        } else {
          vm.errors.maths_or_geography_or_physics = ""
        }
        if (vm.register.high_school_grade == "") {
          vm.errors.high_school_grade = "Please fill in your K.C.S.E Mean Grade"
        } else {
          vm.errors.high_school_grade = ""
        }*/
        if (vm.register.course == "") {
          vm.errors.course = "Please fill in your Course"
        } else {
          vm.errors.course = ""
        }

        vm.step_one = false
        vm.disabled = false
      } else {
        if (
          vm.register.chemistry != "" ||
          vm.register.biology != "" ||
          vm.register.english != "" ||
          vm.register.mathematics != ""
        ) {
          if (
            vm.register.chemistry_qualification == "" &&
            vm.register.chemistry != ""
          ) {
            vm.errors.chemistry_qualification =
              "Please fill in your Chemistry Grade"
          } else {
            vm.errors.chemistry_qualification = ""
          }
          if (
            vm.register.biology_qualification == "" &&
            vm.register.biology != ""
          ) {
            vm.errors.biology_qualification =
              "Please fill in your Biology Grade"
          } else {
            vm.errors.biology_qualification = ""
          }
          if (
            vm.register.english_qualification == "" &&
            vm.register.english != ""
          ) {
            vm.errors.english_qualification =
              "Please fill in your English Grade"
          } else {
            vm.errors.english_qualification = ""
          }
          if (
            vm.register.mathematics_qualification == "" &&
            vm.register.mathematics != ""
          ) {
            vm.errors.mathematics_qualification =
              "Please fill in your Mathematics Grade"
          } else {
            vm.errors.mathematics_qualification = ""
          }
          if (
            (vm.register.chemistry_qualification == "" &&
              vm.register.chemistry != "") ||
            (vm.register.biology_qualification == "" &&
              vm.register.biology != "") ||
            (vm.register.english_qualification == "" &&
              vm.register.english != "") ||
            (vm.register.mathematics_qualification == "" &&
              vm.register.mathematics != "")
          ) {
            vm.check_grade = false
            vm.step_one = false
            vm.disabled = false
          } else {
            vm.check_grade = true
          }
        }

        if (vm.check_grade == true) {
          if (vm.blockedSubjects.length > 0) {
            const reasons = vm.blockedSubjects.map(b => b.reason).join("\n")
            swal({
              title: "Subject Not Required",
              text: reasons,
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            return
          }
          if (!vm.register.grade_declaration) {
            swal({
              title: "Declaration Required",
              text:
                "Please confirm that your KCSE grades are correct before proceeding.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            return
          }
          vm.checkNationalId()
        } /*else {
          swal({
            title: "Failed",
            text:
              "Your are not eligible for KNDI Indexing. K.C.S.E Cluster Subjects or K.C.S.E Mean Grade do not meet the requirements",
            type: "warning",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
          vm.step_one = false
          vm.disabled = false
        }*/
      }
    },
    StepTwo() {
      var vm = this
      vm.disabled = true
      if (
        vm.register.sname == "" ||
        vm.register.fname == "" ||
        vm.register.phone_number == "" ||
        vm.register.email == "" ||
        vm.register.dob == "" ||
        vm.register.gender == "" ||
        vm.register.county == "" ||
        vm.register.address == ""
      ) {
        if (vm.register.sname == "") {
          vm.errors.sname = "Please fill in your Surname"
        } else {
          vm.errors.sname = ""
        }
        if (vm.register.phone_number == "") {
          vm.errors.phone_number = "Please fill in your phone number"
        } else {
          vm.errors.phone_number = ""
        }
        if (vm.register.fname == "") {
          vm.errors.fname = "Please fill in your First name"
        } else {
          vm.errors.fname = ""
        }
        if (vm.register.email == "") {
          vm.errors.email = "Please fill in your Email"
        } else {
          vm.errors.email = ""
        }
        if (vm.register.gender == "") {
          vm.errors.gender = "Please fill in your Gender"
        } else {
          vm.errors.gender = ""
        }
        if (vm.register.dob == "") {
          vm.errors.dob = "Please fill in your Date of Birth"
        } else {
          vm.errors.dob = ""
        }
        if (vm.register.address == "") {
          vm.errors.address = "Please fill in your postal address"
        } else {
          vm.errors.address = ""
        }
        vm.step_two = false
        vm.disabled = false
      } else {
        vm.checkTwo()
      }
    },
    StepThree() {
      var vm = this
      vm.disabled = true

      if (vm.register.file_a != "") {
        vm.errors.file_a = ""
        const data = {
          id: vm.token,
          admission_letter: vm.register.file_a
        }
        vm.dialog_loading = true
        axios
          .post(upgrading_exam_file_uploadUrl, data)
          .then(function(response) {
            if (response.data.stored) {
              vm.e1 = 4
              vm.step_three = true
              vm.disabled = false
              vm.dialog_loading = false
            } else if (response.data.file_error) {
              swal({
                title: "File error",
                text: "Please upload PDF, JPG or PNG Format only",
                type: "warning",
                confirmButtonColor: "#cddc39",
                confirmButtonText: "OK"
              })
              vm.disabled = false
              vm.dialog_loading = false
            }
          })
          .catch(function(error) {
            console.log(error)
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.dialog_loading = false
            if (error.message == "Network Error") {
              vm.snackbar_text =
                "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
              vm.snackbar = true
              vm.x = "right"
              vm.y = "top"
              vm.mode = "multi-line"
            }
          })
      } else {
        vm.step_three = false
        vm.disabled = false
        vm.errors.file_a =
          "Please upload your training institution admission letter"
      }
    },
    StepFour() {
      var vm = this
      vm.disabled = true

      if (vm.register.file_k != "") {
        vm.errors.file_k = ""
        const data = {
          id: vm.token,
          secondary_certificate: vm.register.file_k
        }
        vm.dialog_loading = true
        axios
          .post(upgrading_exam_file_uploadUrl, data)
          .then(function(response) {
            if (response.data.stored) {
              vm.e1 = 5
              vm.step_four = true
              vm.disabled = false
              vm.dialog_loading = false
            } else if (response.data.file_error) {
              swal({
                title: "File error",
                text: "Please upload PDF, JPG or PNG Format only",
                type: "warning",
                confirmButtonColor: "#cddc39",
                confirmButtonText: "OK"
              })
              vm.disabled = false
              vm.dialog_loading = false
            }
          })
          .catch(function(error) {
            console.log(error)
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.dialog_loading = false
            if (error.message == "Network Error") {
              vm.snackbar_text =
                "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
              vm.snackbar = true
              vm.x = "right"
              vm.y = "top"
              vm.mode = "multi-line"
            }
          })
      } else {
        vm.step_four = false
        vm.disabled = false
        vm.errors.file_k = "Please upload your secondary school certificate"
      }
    },
    StepFive() {
      var vm = this
      vm.disabled = true

      if (vm.register.file_s != "" && vm.register.file_id != "") {
        vm.errors.file_s = ""
        vm.errors.file_id = ""
        const data = {
          id: vm.token,
          student_agreement_form: vm.register.file_s
        }
        //vm.dialog_loading = true
        axios
          .post(upgrading_exam_file_uploadUrl, data)
          .then(function(response) {
            if (response.data.stored) {
              //vm.e1 = 5
              vm.step_five = true
              // Mandatory as of 29 Sep. Uses the same endpoint and token as
              // every other document on this application; a failure here must
              // block the application, same as any other required document.
              axios
                .post(upgrading_exam_file_uploadUrl, {
                  id: vm.token,
                  identification_document: vm.register.file_id
                })
                .then(function() {
                  vm.submit()
                })
                .catch(function(error) {
                  console.log(error)
                  vm.disabled = false
                  vm.dialog_loading = false
                  vm.errors.file_id =
                    "Failed to upload, please try again"
                })
            } else if (response.data.file_error) {
              swal({
                title: "File error",
                text: "Please upload PDF, JPG or PNG Format only",
                type: "warning",
                confirmButtonColor: "#cddc39",
                confirmButtonText: "OK"
              })
              vm.disabled = false
              vm.dialog_loading = false
            }
          })
          .catch(function(error) {
            console.log(error)
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.dialog_loading = false
            if (error.message == "Network Error") {
              vm.snackbar_text =
                "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
              vm.snackbar = true
              vm.x = "right"
              vm.y = "top"
              vm.mode = "multi-line"
            }
          })
      } else {
        vm.step_four = false
        vm.disabled = false
        if (vm.register.file_s == "") {
          vm.errors.file_s = "Please upload your student agreement form"
        }
        if (vm.register.file_id == "") {
          vm.errors.file_id = "Please upload your national ID or birth certificate"
        }
      }
    },
    submit() {
      var vm = this
      //vm.disabled = true

      const data = {
        email: vm.register.email,
        national_id: vm.register.national_id,
        phone_number: vm.register.phone_number,
        admission_year: vm.register.admission_year,
        fname: vm.register.fname,
        sname: vm.register.sname,
        mname: vm.register.mname,
        gender: vm.register.gender,
        county: vm.register.county,
        address: vm.register.address,
        dob: vm.register.dob,
        institution_admission_number: vm.register.institution_admission_number,
        training_institution: vm.register.training_institution,
        chemistry: vm.register.chemistry,
        biology: vm.register.biology,
        english: vm.register.english,
        mathematics: vm.register.mathematics,
        chemistry_qualification: vm.register.chemistry_qualification,
        biology_qualification: vm.register.biology_qualification,
        english_qualification: vm.register.english_qualification,
        mathematics_qualification: vm.register.mathematics_qualification,
        course: vm.register.course,
        exam_period: vm.register.exam_period,
        chemistry_grade: vm.register.chemistry_grade,
        physical_sciences_grade: vm.register.physical_sciences_grade,
        biology_grade: vm.register.biology_grade,
        biological_sciences_grade: vm.register.biological_sciences_grade,
        english_grade: vm.register.english_grade,
        kiswahili_grade: vm.register.kiswahili_grade,
        mathematics_grade: vm.register.mathematics_grade,
        geography_grade: vm.register.geography_grade,
        physics_grade: vm.register.physics_grade,
        home_science_grade: vm.register.home_science_grade,
        agriculture_grade: vm.register.agriculture_grade,
        token: vm.token
      }

      axios
        .post(upgradeExamRegisterUrl, data)
        .then(function(response) {
          vm.disabled = false
          vm.dialog_loading = false
          if (response.data.stored) {
            vm.e1 = 1
            vm.dialog = true
            vm.check_resit = true
            vm.register.email = ""
            vm.register.national_id = ""
            vm.register.phone_number = ""
            vm.register.admission_year = ""
            vm.register.fname = ""
            vm.register.sname = ""
            vm.register.mname = ""
            vm.register.county = ""
            vm.register.dob = ""
            vm.register.gender = ""
            vm.register.address = ""
            vm.register.exam_period = ""
            vm.register.training_institution = ""
            vm.register.institution_admission_number = ""
            vm.register.chemistry = ""
            vm.register.biology = ""
            vm.register.english = ""
            vm.register.mathematics = ""
            vm.register.chemistry_qualification = ""
            vm.register.biology_qualification = ""
            vm.register.english_qualification = ""
            vm.register.mathematics_qualification = ""
            vm.register.high_school_grade = ""
            vm.register.course = ""
            vm.register.file_a = ""
            vm.register.file_k = ""
            vm.register.file_s = ""
            vm.file_name_a = ""
            vm.file_name_c = ""
            vm.file_name_k = ""
            vm.file_name_s = ""

            swal({
              title: "Success",
              text:
                "Please check your email right now for further instructions",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
            vm.disabled = false
          } else if (response.data.unauthorized) {
            swal({
              title: "Failed",
              text: "Please contact KNDI through exam@kndi.institute",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
            vm.disabled = false
          }
        })
        .catch(function(error) {
          console.log(error)
          Vue.set(vm.$data, "errors", error.response.data)
          vm.disabled = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/stepper/upgrading-exam-register.vue